import React from 'react';
type FormFieldProps = {
  id: string;
  label: string;
  optional?: boolean;
  error?: string;
  className?: string;
  children: React.ReactNode;
};
export function FormField({
  id,
  label,
  optional,
  error,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-241" data-mp="3hg27jvt3z542">
      <label htmlFor={id} className="mb-2 flex items-baseline justify-between text-small-fluid font-semibold text-brand-slate" data-id="element-242" data-mp="3mggcv63bs0ye">
        {label}
        {optional && <span className="text-[0.8em] font-medium text-brand-gray" data-id="element-243" data-mp="dz3ljg63x6my">Optional</span>}
      </label>
      {children}
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-sm font-medium text-[#b42318]" data-id="element-244" data-mp="43i9sqb8ks00">
          {error}
        </p>}
    </div>;
}